import Service from "../../../Services/index";
const factoryEmployeeImport = {
    namespaced : true,
    state : {
        form :{
            id : '',
            employee : '',
            employee_id : '',
            hr_factory_id : '',
            factory : '',
            quantity : '',
            user_id : ''
        }
    },
    mutations : {
        GET_FORM:(state,res)=>{
            state.form = res;
        },
        CLEAR_FORM_DATA :(state)=>{
            state.form  ={
                employee_id : '',
                hr_factory_id : '',
                quantity : '',
                user_id : ''
            };
        }
    },
    actions : {
        getFactoryEmployeeImport({commit}, {page,data}){
            return Service.factoryEmployeeImport.getFactoryEmployeeImport(page,data);
        },
        showFactoryEmployeeImport({commit},id){
            return Service.factoryEmployeeImport.showFactoryEmployeeImport(id);
        },
        saveFactoryEmployeeImport({commit},{id,data}){
            if(id){
                return Service.factoryEmployeeImport.updateFactoryEmployeeImport(id,data);
            }else{
                return Service.factoryEmployeeImport.createFactoryEmployeeImport(data);
            }
        },
        deleteFactoryEmployeeImport({commit},id){
            return Service.factoryEmployeeImport.deleteFactoryEmployeeImport(id);
        },
        setFormFactoryEmployeeImport({commit},res){
            commit('GET_FORM',res);
        },
        clearFormDataFactoryEmployeeImport({commit}){
            commit('CLEAR_FORM_DATA');
        }
    },
}
export default factoryEmployeeImport
